Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfiguration = void 0;
var _react = require("react");
var _ConfigurationContext = require("./ConfigurationContext");
var missingConfigurationContextWarning = "No configuration context has been registered.";
var useConfiguration = exports.useConfiguration = function useConfiguration() {
  var context = (0, _react.useContext)(_ConfigurationContext.ConfigurationContext);
  if (!context) {
    throw new Error(missingConfigurationContextWarning);
  }
  return context;
};